<template>
  <LoadingComponent v-if="loadingPage" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-6"><h6>Contratos Domiciliación</h6></div>
              <div class="col-md-6 text-end">
                <router-link
                  :to="{ name: 'crear-contrato-domiciliacion' }"
                  class="btn bg-gradient-primary btn-xs"
                  ><i class="ri-add-line me-1"></i>
                  Nuevo contrato
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 vh-50">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      No. Contrato
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Descripción
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Periodo
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Datos bancarios
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in contratosDomiciliacion" :key="row.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div
                          class="icon icon-shape icon-sm me-3 bg-gradient-info shadow text-center"
                        >
                          <i class="ri-file-line text-white opacity-10"></i>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        <p class="text-xs text-uppercase text-secondary mb-0">
                          {{ row.no_contrato }}
                        </p>
                      </span>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-xs text-uppercase">
                            {{ truncateString(row.descripcion) }}
                          </h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ row.correo }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <p class="mb-0 text-xs text-capitalize">
                            {{ row.periodo }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-xs text-uppercase">
                            {{ truncateString(row.banco) }}
                          </h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ row.cuenta }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <a :href="urlDownload(row.id)"
                        class="btn btn-link text-xs text-secondary p-0 m-0"
                      >
                        <i class="ri-download-line me-1"></i>
                        Descargar
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useContratos from "@/composables/useContratos";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "Contrato-Domiciliacion",
  components: {
    LoadingComponent,
  },
  setup() {
    const {
      loadingPage,
      contratosDomiciliacion,
      fetchContratosDomiciliacion,
      truncateString,
      urlDownload,
    } = useContratos();

    fetchContratosDomiciliacion();

    return {
      loadingPage,
      contratosDomiciliacion,
      fetchContratosDomiciliacion,
      truncateString,
      urlDownload,
    };
  },
};
</script>

<style></style>
